import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {scopedState}    from "@Common/react/scoped-state";
import {UseState}       from "@Common/react/use-state";

import {isDevQuan}     from "../../../../../debug/is-dev-quan";
import {ConfirmCancel} from "../common/confirm-cancel";
import {Header}        from "../common/header/header";
import {StepFinalize}  from "../common/step-finalize/step-finalize";

import {Step1Search} from "./step-1-search/step-1-search";
import { AltNameTypeConfig } from "../common/alt-name-type-config";

export const Street = ({onClose, cancelLabel="Cancel", onCreated, onCancel, entityId, next}) => cs(
    consumeContext("apis"),
    ["step", (_, next) => UseState({
        initValue: 0,
        // @ts-ignore
        next,
    })],
    ["altNameType", (_, next) => AltNameTypeConfig({next})],
    ["data", ({altNameType}, next) => UseState({
        initValue: {

            streets: 0&&isDevQuan() ? [
                    {
                        "addresses": [
                            {
                                "address": "1342 N Church Ct",
                                "display_address": 1,
                                "doNotMail": 0,
                                "sort_house": 1342
                            },
                            {
                                "address": "2342 N Church Ct",
                                "display_address": 1,
                                "doNotMail": 0,
                                "sort_house": 2342
                            },
                        ],
                        "street": {
                            "count": 1,
                            "min": "1342",
                            "max": "1342",
                            "address": "1342 N CHURCH CT",
                            "city": "BELLBROOK",
                            "zip_code": "45305",
                            "MFI": 1
                        },
                        "key": "testKey"
                    }
                ] : (
                null
            ),
            info: {
                alternateName: {
                    type: altNameType,
                }
            },
        },
        next,
    })],
    ({step, data, apis,}) => (
        step.value === 0 ? cs(
            keyed(1),
            () => Step1Search({
                onCancel, onClose,
                cancelLabel,
                entityId,
                onNext: () => step.onChange(1),
                streets: scopedState(data, ["streets"]),
                next,
            })
        ) : cs(
            keyed(2),
            ["confirmCancel", (_, next) => ConfirmCancel({next})],
            ({confirmCancel}) => next({
                onPassiveClose: confirmCancel,
                content: StepFinalize({
                    header: Header({
                        icon: require("../../../mailing-icons/listtype-street.png"),
                        title: "Finalize Street List",
                        subTitle: "Name your list and approve to generate the order",
                    }),
                    name: "Street",
                    onBack: () => step.onChange(0),
                    data: scopedState(data, ["info"]),
                    getDefaultListName: () => data.value.streets[0].street.address,
                    onComplete: async () => {

                        const result = await apis.next.mailing.createStreetList({
                            streets: data.value.streets.filter((s) => !s.excluded),
                            info: data.value.info,
                            entityId,
                        });

                        // {"result":"failure","errors":{"target":"createRadiusList","msg":"Quantity is required"}}
                        if (result.result === "failure") {
                            alert(result.errors?.msg ?? "Unknown error");
                        } else {
                            onCreated([result.mailingListId]);

                            onClose();
                        }
                    },
                    xdQaName: "Finalize Street List",
                }),
            })
        )
    ),
);
